<template>
	<div class="confirmation-popup" :class="`${$route.path.startsWith('/gop/') ? 'gop-modal' : 'drc-modal'}`" v-if="doShowConfirmationDialog">

		<div class="confirmation-dialog" data-aos="fade-up" data-aos-anchor-placement="center-bottom"
			data-aos-duration="400">
			<template v-if="!hideCancel">
				<img v-if="$route.path.startsWith('/gop/')" src="@/common/assets/icons/x_blue.svg" @click="closeDialog" alt="close-icon">
				<img v-else src="@/common/assets/icons/x_white.svg" @click="closeDialog" alt="close-icon">
			</template>
			<div class="confirmation-content">
				<h3>{{ title || $t('common.areYouSure') }}</h3>
				<p class="text-container">{{ text }}</p>

				<div class="text-field-container" v-if="isWithCkEditor()">
					<p>{{ textFiledTitle }}</p>
					<CKEditor
						:editor="editor"
						:config="editorConfig"
						v-model="ckEditorInputText"
						:key="componentKey"
						@input="focusOut"
					/>
					<div v-if="errors.length > 0">
						<p class="errors" v-for="error in errors" :key="error">
							{{ $t(`common.${error}`) }}
						</p>
					</div>
				</div>

				<div class="radio-field-container" v-if="isRadio()">
					<template v-for="el in options">
						<div class="radio-button" @click="radioValue = el[displayField]" :key="el[displayField]">
							<input type="radio" :id="el[displayField]" :value="el[displayField]" v-model="radioValue" />
							<img class="flag" :src="require(`@/drc/assets/images/flags/${el.short}.svg`)" :alt="el.name">
							<label :for="el[displayField]">{{ el[displayField] }}</label>
						</div>
					</template>
				</div>

				<div class="confirmation-dialog-button-container">
					<button class="confirmation-modal-button" @click="onConfirmClick">
						{{ positiveButtonText }}
					</button>
					<button v-if="!hideCancel" class="confirmation-modal-button cancel" @click="onCancelClick">
						{{ negativeButtonText }}
					</button>
				</div>
			</div>
		</div>

		<div :class="hideCancel ? 'confirmation-popup-backdrop' : ''" @click="!hideCancel ? closeDialog : () => {}"></div>
	</div>
</template>

<script>
import Vue from 'vue'
import { component } from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {EventButton} from "@/common/configurations/event-bus";

export default {
	name: "ConfirmationPopup",
	components: {
		CKEditor: component,
	},
	data() {
		return {
			title: "",
			text: "",
			doShowConfirmationDialog: false,
			positiveButtonText: "",
			negativeButtonText: "",
			textFiledTitle: "",
			editor: ClassicEditor,
			editorConfig: {
				bodyId: "ckEditor",
				placeholder: this.$t('common.commonPopupPlaceholder'),
				toolbar: {
					items: [
						"bold",
						"italic",
						"|",
						"undo",
						"redo",
						"|",
						"link",
						"numberedList",
						"bulletedList",
						"|",
						"heading",
					],
					shouldNotGroupWhenFull: false
				},
			},
			errors: [],
			ckEditorInputText: "",
			componentKey: 1,
			ERROR_TYPES: {
				REQUIRED_TEXT: 'commonPopupError'
			},
			options: [],
			displayField: '',
			radioValue: '',
			hideCancel: false
		}
	},
	methods: {
		focusOut() {
			if (this.ckEditorInputText.trim() !== "" && this.errors.includes(this.ERROR_TYPES.REQUIRED_TEXT)) {
				this.errors = this.errors.filter(item => item !== this.ERROR_TYPES.REQUIRED_TEXT);
			}
		},
		closeDialog() {
			this.doShowConfirmationDialog = false;
			this.title = "";
			this.text = "";
			this.ckEditorInputText = ""
			this.errors = [];
			this.hideCancel = false;
		},
		onCancel() { },
		onCancelClick() {
			if (this.onCancel && typeof this.onCancel === 'function') {
				this.onCancel();
			}
			this.errors = [];
			this.closeDialog();
		},
		onConfirm() { },
		onConfirmClick() {
			if (this.isWithCkEditor()) {
				EventButton.$emit('sendCkEditorContent', this.ckEditorInputText)
			}

			if (this.isWithCkEditor() && (!this.ckEditorInputText || this.ckEditorInputText.trim() === "")) {
				this.errors = [this.ERROR_TYPES.REQUIRED_TEXT];
			} else {
				this.confirmAction(this.isWithCkEditor() ? this.ckEditorInputText : undefined);
				this.errors = [];
			}
		},
		isWithCkEditor() {
			return this.textFiledTitle && this.textFiledTitle.trim() !== ''
		},
		isRadio(){
			return this.options?.length > 0 && this.displayField;
		},
		confirmAction(ckEditorText) {
			if (this.onConfirm && typeof this.onConfirm === 'function') {
				this.onConfirm(ckEditorText);
			}
			if(this.onConfirm && this.isRadio()){
				this.onConfirm(this.options.find(el => el[this.displayField] === this.radioValue));
			}
			this.closeDialog();
		},
		openPopupModal({ title, text, onConfirm, onCancel, positiveButtonText, negativeButtonText, textFiledTitle, hideCancel, options, displayField}) {
			this.doShowConfirmationDialog = true;
			this.title = title;
			this.text = text;
			this.hideCancel = hideCancel;
			this.onConfirm = onConfirm;
			this.onCancel = onCancel
			this.positiveButtonText = positiveButtonText ? positiveButtonText : this.$t('common.yes');
			this.negativeButtonText = negativeButtonText ? negativeButtonText : this.$t('common.no');
			this.textFiledTitle = textFiledTitle;
			this.options = options;
			this.displayField = displayField;
			if(this.isRadio()){
				this.radioValue = this.options[0][displayField];
			}
		}
	},
	created() {
		Vue.prototype.$dialog = {
			closeDialog: this.closeDialog,
			openPopupModal: this.openPopupModal,
			isOpen: () => this.doShowConfirmationDialog
		};
	},
	destroyed() {
		this.errors = [];
	},
	watch: {
		'$i18n.locale': {
			immediate: true,
			handler() {
				this.editorConfig.placeholder = this.$t('common.commonPopupPlaceholder')
				this.componentKey++;
			}
		}
	}
}
</script>

<style lang="scss">
@import "@/common/assets/css/_variables.scss";

.gop-modal {
	.confirmation-dialog{
		background-color: $newsletter-button-text;
		color: $newsletter-hover-background;
	}
	.confirmation-modal-button, .confirmation-modal-button.cancel {
		transition-duration: 0.5s;
		background-color: $newsletter-button-text;
		color: $newsletter-hover-background;
		border: 1px solid $newsletter-hover-background;

		&:hover{
			background-color: $newsletter-hover-background;
			color: $newsletter-button-text;
		}
	}
}

.drc-modal {
	.confirmation-dialog {
		width: 421px;
		background-color: #FFFFFF;
		color: #001F33;
		border-radius: 0;

		.confirmation-content {
			margin: 0 28px;

			h3 {
				color: #001F33;
				font-family: Tiempos Headline, serif;
				font-weight: bold;
				font-size: 28px;
				line-height: 34px;
				letter-spacing: 0.36px;
			}

			.text-container {
				color: #636366;
				font-family: Roboto, serif;
				font-weight: 400;
				font-size: 17px;
				line-height: 22px;
				letter-spacing: 0;

			}
		}
	}

	.confirmation-modal-button {
		border-radius: 0;
		max-width: 357px;
		width: 100%;
		height: 54px;
		gap: 12px;
		padding: 16px 24px;
	}
}

.confirmation-popup {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 200;
	display: flex;
	justify-content: center;

	&>div:nth-child(2) {
		height: 100vh;
		width: 100vw;
		background-color: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}
}

.confirmation-dialog {
	max-width: 688px;
	border-radius: 6px;
	margin: 200px 5px 0 5px;
	background-color: $grey;
	position: relative;
	width: 90%;
	max-height: 60vh;
	overflow: auto;
	scrollbar-width: thin;
	opacity: 1 !important;

	.radio-field-container {
		display: flex;
		flex-direction: column;
		gap: 10px;

		.radio-button {
			cursor: pointer;
			font-size: 1rem;
			margin: 2px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-items: center;

			img {
				width: 18px;
				margin: 0 5px 2px;
			}

			img, label, input {
				cursor: pointer;
			}

			input {
				align-self: flex-start;
				margin: 0 8px 0 0;
				height: 18px;
				width: 18px;
			}
		}
	}

	&::-webkit-scrollbar {
		width: 5px;
		padding: 0 2px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
	}

	&::-webkit-scrollbar-thumb {
		background: #FDB71A;
	}

	-webkit-border-radius: 10px {
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #555;
	}

	p {
		font-size: 1rem;
		line-height: 1rem;
	}

	&>img {
		position: absolute;
		top: 5px;
		right: 5px;
		height: 18px;
		width: 18px;
		margin: 16px 16px 0 0;
		cursor: pointer;
	}

	.confirmation-content {
		margin: 0 64px;

		.text-field-container {
			margin: 0;
			--ck-font-size-base: 14px;

			.ck-editor {
				.ck-editor__main {
					.ck-editor__editable {
						p, li {
							font-size: 17px;
							line-height: 21px;
							color: black;
						}

						h1, h2, h3, h4, h5, h6 {
							line-height: 21px;
							color: black;
						}

						a {
							line-height: 21px;
							color: blue;
							text-decoration: underline;
							cursor: pointer;
						}
					}
				}
			}

			.errors {
				color: red;
				margin-top: 5px;
				margin-bottom: 0;
				font-size: 15px;
			}
		}

		@media (max-width: 600px) {
			padding-top: 20px;
			margin-right: 20px;
			margin-left: 20px;
		}

	}

	button:hover {
		opacity: 0.8;
	}

	.confirmation-dialog-button-container {
		text-align: center;
		margin: 32px 0 16px 0
	}
}

.confirmation-modal-button {
	background: #001f33;
	color: white;
	border-radius: 5px;
	margin: 6px 8px;
	font-size: 18px;
	font-weight: 500;
	padding: 15px 30px;
	outline: none;
	border: 0;
	cursor: pointer;

	&.cancel {
		background: $color-disabled-button-backgroud;
	}

	&:disabled {
		cursor: not-allowed;
	}

	img {
		margin-bottom: 2px;
		width: 20px;
		animation: rotateLoading 3s linear infinite;
	}
}

@keyframes rotateLoading {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
